import React from "react";
import { Badge } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { useSanctum } from "react-sanctum";
import apiClient from "../../services/api";
import { usePermissions } from "../../hooks/usePermissions";

const NotificationBell = () => {
  const { user } = useSanctum();
  const { hasBillingAccess } = usePermissions();

  const { data: unreadNotifications } = useQuery(
    "unread_notifications",
    async () => {
      if (user) {
        const response = await apiClient.get("/notifications/unread");
        return response.data || [];
      }
      return [];
    },
    { enabled: !!user && hasBillingAccess, refetchInterval: 60000 }
  );

  if (!hasBillingAccess) {
    return null;
  }

  return (
    <Link to="/inbox" style={{ marginRight: "24px", cursor: "pointer", marginTop: "6px" }}>
      <Badge count={unreadNotifications?.length || 0} size="small">
        <BellOutlined style={{ fontSize: "20px", color: "inherit" }} />
      </Badge>
    </Link>
  );
};

export default NotificationBell;
